module.exports = __webpack_public_path__ + "d256bea1c005632ceaffee056c88a67b.png";